import { memo as Memo, useState, useEffect } from 'react';
import { find, includes } from 'lodash';

//* Helpers
import getTimes from '@helpers/getTimes';

//* Components
import Select from '../Select';
import Text from '@/components/global/Text';

const Timepicker = Memo((props) => {
	//! Constructing Object For Select Element
	const selectProps = () => {
		let obj = {
			name: props.name,
			required: props.required,
			placeholder: props.placeholder,
			mobileDefault: props.mobileDefault || true,
			leftIcon: props.leftIcon || (
				<Text
					tag={'span'}
					className='ma-clock'>
					<Text
						tag={'span'}
						className='path1'
					/>
					<Text
						tag={'span'}
						className='path2'
					/>
				</Text>
			),
			type: props.multi ? 'object' : 'text',
		};

		const times = getTimes(props.date, !!props.multi, props.interval, props.minDeliveryTime);

		const length = times.length;
		let list = [];
		for (let i = 0; i < length; i++) {
			const value = times[i],
				label = props.multi ? times[i].min + ' - ' + times[i].max : times[i];

			const newObj = { label, value };

			list = [...list, newObj];

			let isExists = typeof props.parentVal === 'object' ? !find(times, props.parentVal) : !includes(times, props.parentVal);

			if ((props.parentVal && isExists && i === 0) || (!props.parentVal && props.hasValue && i === 0)) {
				obj = { ...obj, changeValue: newObj };
			}
		}

		obj = { ...obj, list };
		return obj;
	};

	//! States
	const [selectObj, setSelectObj] = useState(selectProps);

	//! Update Select Object
	useEffect(() => {
		setSelectObj(selectProps());
	}, []);

	//! If Date Prop Exists and Changed Update Select Object
	useEffect(() => {
		setSelectObj(selectProps());
	}, [props.date]);

	return (
		<div className={`timepicker-cont`}>
			<Select
				{...props}
				{...selectObj}
				onChange={props.onChange}
			/>
		</div>
	);
});

export default Timepicker;
